import { configureStore } from "@reduxjs/toolkit";
import ActiveSlice from "./slice/ActiveSlice";

const NewStore = configureStore({
    reducer: {
        listActive: ActiveSlice,
    }
});


export default NewStore;